export { default } from './CompactItemInfo';



// WEBPACK FOOTER //
// ./app/components/shared/CompactItemInfo/index.js